import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { useDispatch, useSelector } from "react-redux";
// import { setNotification } from "../../helpers/notification";
import moment from "moment";
import Loading from "../Loading";
import {
  convertAmountToFrontend,
  convertNumberToFrontend,
} from "../../helpers/convert";
import TitleValue from "../TitleValue/TitleValue";
import { Select, Textarea } from "../Inputs";
import Button from "../Button";
import { useTranslation } from "react-i18next";
import { sendCancalledMatchesRequested } from "../../redux/actions/offers";
import ModalConfirmation from "./ModalConfirmation";
export default function MarketMatchModal(props) {
  const { t } = useTranslation();

  const {
    buyerOrganization,
    sellerOrganization,
    matchDate,
    price,
    quantity,
    contractName,
    marketMatchId,
    isOpen,
    toggle,
    matchList,
    reqFonks,
  } = props;
  const dispatch = useDispatch();
  const [cancelledMatcObj, setCancelledMatcObj] = useState({
    matchStatus: "Hatalı",
    matchDescription: "",
    matchIds: null,
  });
  const [userParametersConfirmationModal, setUserParametersConfirmationModal] =
    useState(false);
  const matchIds = [];

  useEffect(() => {
    matchList.map((item) => matchIds.push(item?.id));
    setCancelledMatcObj(() => ({
      ...cancelledMatcObj,
      matchIds: matchIds,
    }));
  }, []);

  const handleCancelled = (e) => {
    const { name, value } = e.target;

    setCancelledMatcObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleClick = () => {
    reqFonks();
    if (userParametersConfirmationModal) {
      dispatch(sendCancalledMatchesRequested(cancelledMatcObj));
      setUserParametersConfirmationModal(false);
    }
    toggle();
    return true;
  };

  const sendmarketMatchToggle = () => {
    setUserParametersConfirmationModal(true);
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <>
          <div className="km__p--certificate-edit-header">
            {t("pages.default.offersAndMatches.modalTitle")}
          </div>
          <div className="km__p--certificate-edit-body">
            <TitleValue
              title={t("pages.default.offersAndMatches.buyerOrganization")}
              value={buyerOrganization}
              size="lg"
            />
            <TitleValue
              title={t("pages.default.offersAndMatches.sellerOrganization")}
              value={sellerOrganization}
              size="lg"
            />
            <TitleValue
              title={t("pages.default.offersAndMatches.matchPrice")}
              value={convertNumberToFrontend({ num: price, digit: 2 })}
              size="lg"
            />
            <TitleValue
              title={t("pages.default.offersAndMatches.matchAmount")}
              value={convertAmountToFrontend(quantity)}
              size="lg"
            />
            <TitleValue
              title={t("pages.default.offersAndMatches.matchDate")}
              value={moment(matchDate).format("DD.MM.YYYY HH:mm:ss")}
              size="lg"
            />
            <TitleValue
              title={t("pages.default.offersAndMatches.contract")}
              value={contractName}
              size="lg"
            />
            <Textarea
              label={t("pages.default.offersAndMatches.cancelDescription")}
              name="matchDescription"
              value={cancelledMatcObj?.matchDescription}
              // value={
              //   editedCertificateChanges.certificateStatus === "CANCEL"
              //     ? editedCertificateChanges.description
              //     : ""
              // }
              maxLength="255"
              // disabled={editedCertificateChanges.certificateStatus === "REPEAL"}
              // onChange={editCertificateChange}
              onChange={(e) => handleCancelled(e)}
            />
            <Select
              label={t("pages.default.offersAndMatches.status")}
              name="matchStatus"
              value={cancelledMatcObj?.matchStatus}
              options={[
                // { name: "", value: "-", disabled: true },
                { name: "Hatalı", value: "Cancelled" },
              ]}
              onChange={(e) => handleCancelled(e)}
            />
          </div>
          <div className="km__p--certificate-edit-footer">
            <Button
              label={t("pages.default.certificates.table.dismiss")}
              type="danger"
              onClick={toggle}
            />
            <Button
              label={t("pages.default.offersAndMatches.save")}
              type="primary"
              onClick={sendmarketMatchToggle}
            />
          </div>

          {!marketMatchId && (
            <div className="km__c--modal-certificate-loading">
              <Loading />
            </div>
          )}
        </>
      </Modal>
      <ModalConfirmation
        isOpen={userParametersConfirmationModal}
        toggle={() =>
          setUserParametersConfirmationModal(!userParametersConfirmationModal)
        }
        header={t("pages.default.offersAndMatches.modal.cancelConfirmTitle")}
        body={t("pages.default.offersAndMatches.modal.cancelConfirmBody")}
        approve={handleClick}
      />
    </>
  );
}
